import { createSlice, current } from '@reduxjs/toolkit'

// MARK: --- Thunks ---
const STATUS_PRIORITY = {
  watting: 1,
  processing: 2,
  error: 3,
  success: 4,
}

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    appSpinning: false,
    appNotificationModalShow: false,
    appNotificationInfo: {
      title: '',
      describeText: '',
      icon: '',
    },
    // 🔥 thêm vào đây
    drawerDowloadFie: {
      show: false,
      files: [],
    },
  },
  reducers: {
    setAppSpinning: (state, action) => {
      state.appSpinning = !!action.payload
    },
    showNotification: (state, action) => {
      let { title, describeText, icon } = action.payload
      state.appNotificationInfo.title = title
      state.appNotificationInfo.describeText = describeText
      state.appNotificationInfo.icon = icon

      state.appNotificationModalShow = true
    },
    hideNotification: (state) => {
      state.appNotificationInfo.title = ''
      state.appNotificationInfo.describeText = ''
      state.appNotificationModalShow = false
    },
    clearDrawerDowloadFie: (state) => {
      state.drawerDowloadFie.data = []
    },
    setDrawerDowloadFie: (state, action) => {
      // console.log('OLD:', current(state).drawerDowloadFie)
      // console.log('action.payload', action.payload)
      const payload = action.payload

      const SORT_PRIORITY = {
        error: 4,
        processing: 3,
        watting: 2, // nhớ đúng chính tả bên mày đang dùng
        success: 1,
      }

      // clone để tránh mutate ngoài ý muốn
      const newData = payload?.data
        ? [...payload.data].sort((a, b) => {
            const priorityA = SORT_PRIORITY[a.status] || 0
            const priorityB = SORT_PRIORITY[b.status] || 0
            return priorityB - priorityA // 🔥 cao -> thấp
          })
        : []

      state.drawerDowloadFie = {
        ...payload,
        data: newData,
      }
    },
    updateDrawerFileItem: (state, action) => {
      const payload = action.payload

      if (!state.drawerDowloadFie) return

      let { invoiceId, status, fileURL, fileURLXML, fileName, fileNameXML } =
        payload
      //console.log('fileURLXML', fileURLXML)
      // parse invoiceId
      if (!invoiceId && fileName) {
        const match = fileName.match(/invoice_(.+?)_/)
        if (match) invoiceId = match[1]
      }

      if (!invoiceId) return

      if (!Array.isArray(state.drawerDowloadFie.data)) {
        state.drawerDowloadFie.data = []
      }

      const list = state.drawerDowloadFie.data
      const item = list.find((i) => i.invoiceId == invoiceId)

      if (!item) return

      const normalize = (s) => (s ? s.toLowerCase().trim() : '')

      // ✅ priority dùng để UPDATE
      const UPDATE_PRIORITY = {
        watting: 1,
        processing: 2,
        error: 3,
        success: 4,
      }

      // ✅ priority dùng để SORT
      const SORT_PRIORITY = {
        error: 4,
        processing: 3,
        watting: 2,
        success: 1,
      }

      const currentPriority = UPDATE_PRIORITY[normalize(item.status)] ?? -1
      const newPriority = UPDATE_PRIORITY[normalize(status)] ?? -1

      // ✅ chỉ update status khi priority cao hơn
      if (newPriority > currentPriority) {
        item.status = normalize(status)
      }

      // ✅ LUÔN update file (không phụ thuộc status)
      if (fileName?.endsWith('.pdf')) {
        item.pdf = {
          ...item.pdf,
          fileURL: fileURL ?? item?.pdf?.fileURL,
        }
      }

      if (fileNameXML?.endsWith('.xml')) {
        item.xml = {
          ...item.xml,
          fileURL: fileURLXML ?? item?.xml?.fileURL,
        }
      }

      // ✅ SORT theo priority hiển thị
      list.sort((a, b) => {
        const pa = SORT_PRIORITY[normalize(a.status)] ?? -1
        const pb = SORT_PRIORITY[normalize(b.status)] ?? -1
        return pb - pa
      })

      // ép render
      state.drawerDowloadFie.data = [...list]
    },
    addFileDownload: (state, action) => {
      const newFile = action.payload
      console.log('action.payload', action.payload)
      const index = state.drawerDowloadFie.files.findIndex(
        (f) => f.invoiceId === newFile.invoiceId,
      )

      if (index !== -1) {
        // update file cũ
        state.drawerDowloadFie.files[index] = {
          ...state.drawerDowloadFie.files[index],
          ...newFile,
        }
      } else {
        // thêm mới
        state.drawerDowloadFie.files.push(newFile)
      }

      // 🔥 auto mở drawer khi có file
      state.drawerDowloadFie.show = true
    },
  },
  extraReducers: {},
})

const { reducer, actions } = appSlice
export const {
  setAppSpinning,
  showNotification,
  hideNotification,
  setDrawerDowloadFie, // 🔥 thêm dòng này
  updateDrawerFileItem,
  clearDrawerDowloadFie,
} = actions
export default reducer
